export function formatTime(timeInSeconds) {
  if (timeInSeconds === null) return '';
  if (timeInSeconds < 0) return '00:00:00';

  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds - hours * 3600) / 60);
  const seconds = Math.floor(timeInSeconds - hours * 3600 - minutes * 60);

  function padValue(value) {
    return value.toString().padStart(2, '0');
  }

  return `${padValue(hours)}:${padValue(minutes)}:${padValue(seconds)}`;
}
